import { ofType } from 'redux-observable';

import { ajax } from 'rxjs/ajax';

import { of } from 'rxjs';

import { map, switchMap, catchError } from 'rxjs/operators';

import {
  SERVER_STATUS_CHECKING,
  SERVER_STATUS_OK,
  SERVER_STATUS_ERROR,
} from '../../constants';

const serverStatusCheck = (action$, state$) =>
  action$.pipe(
    ofType(SERVER_STATUS_CHECKING),
    switchMap(action =>
      ajax({
        url: `${state$.value.auth.server}/healthz?v=${process.env.REACT_APP_VERSION}`,
        responseType: 'json',
        headers: {
          Authorization: state$.value.auth.token,
        },
        crossDomain: true,
      }).pipe(
        map(response => {
          return {
            type: SERVER_STATUS_OK,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: SERVER_STATUS_ERROR,
            error,
          })
        )
      )
    )
  );

export default serverStatusCheck;
